module.exports = __webpack_public_path__ + "assets/img/report_l1.16af5f7f.png";